import React from 'react';
import PixiScaledSprite from "./PixiScaledSprite"
import PixiScaledText from "./PixiScaledText"
import { Container } from '@pixi/react';
import { gameStateManager } from '../../App';
import { pixiGameUtils } from '../PixiGame/PixiGameUtils'
import PixiGamePositionRibbon from "./PixiGamePositionRibbon"

class PixiEndGamePhasePanel extends React.Component
{
  render()
  {
    const stageRenderData = this.props.stageRenderData;
    const playerData = this.props.playerData;
    const clientId = this.props.clientId;

    const numPlayers = playerData.playersJoined.length;

    const rowSpacing = 5;
    const rowHeight = 80;

    // Combine the scores and player name info into single objects in an array
    let endGamePlayerData = [];

    for( let idx = 0; idx < numPlayers; idx++ )
    {
      endGamePlayerData.push(
        {
          username: playerData.playersJoined[ idx ].username,
          score: playerData.scores[ idx ],
          isClient: playerData.playersJoined[ idx ].socketID === clientId,
          isHuman: !playerData.playersJoined[ idx ].isBot,
          colourHex: playerData.playersJoined[ idx ].colourHex,
          colourID: playerData.playersJoined[ idx ].colourID
        }
      );
    }

    // Sort player data list by scores, highest to lowest
    endGamePlayerData.sort( ( pd1, pd2 ) => { return pd2.score - pd1.score; } );

    let positionTabsContent = [];
    let positionIndex = 0;

    for( let idx = 0; idx < numPlayers; idx++ )
    {
      const currentPlayerData = endGamePlayerData[ idx ];

      if( idx > 0 && currentPlayerData.score < endGamePlayerData[ idx - 1 ].score )
      {
        positionIndex++;
      }

      positionTabsContent.push(
        <PixiScaledSprite
          key={ `position-tab-bg-${idx}` }
          imageSrc={ "./ui/panel_bg.png" }
          isNineSlice={ true }
          cornerRadius={ 15 }
          stageRenderData={ stageRenderData }
          x={ 0 }
          y={ idx * ( rowHeight + rowSpacing ) }
          width={ 110 }
          height={ rowHeight }
          anchor={ { x: 0, y: 0 } } />,

        <PixiGamePositionRibbon
          key={ `position-tab-ribbon-${idx}` }
          x={ 74 * stageRenderData.scale }
          y={ ( idx * ( rowHeight + rowSpacing ) ) + ( rowHeight / 2 ) - 2 }
          positionIndex={ positionIndex }
          stageRenderData={ stageRenderData }
          scale={ 0.9 }
        />
      );
    }





    let playerScoreSegments = [];

    const stageHeight = stageRenderData.height;
    const renderScale = stageRenderData.scale;
    const stageHeightRef = gameStateManager.canvasRefHeight;
    positionIndex = 0;

    for( let idx = 0; idx < numPlayers; idx++ )
    {
      const currentPlayerData = endGamePlayerData[ idx ];

      if( idx > 0 && currentPlayerData.score < endGamePlayerData[ idx - 1 ].score )
      {
        positionIndex++;
      }

      let yContainerPos = idx * ( rowHeight + rowSpacing );

      let playerIconSprite = pixiGameUtils.getPlayerIconSprite( currentPlayerData );

      playerScoreSegments.push(

        <Container
          key={ `end-phase-player-tab-${idx}` }
          x={ 108 * renderScale }
          y={ ( yContainerPos / stageHeightRef ) * stageHeight }>

          <PixiScaledSprite
            imageSrc={ "./ui/panel_bg.png" }
            isNineSlice={ true }
            cornerRadius={ 15 }
            stageRenderData={ stageRenderData }
            x={ 0 }
            y={ 0 }
            width={ 116 }
            height={ rowHeight }
            tint={ currentPlayerData.isClient ? '0xbbbbbb' : '0xffffff' }
            anchor={ { x: 0, y: 0 } } />

          <PixiScaledSprite
            imageSrc={ playerIconSprite }
            stageRenderData={ stageRenderData }
            x={ 32 * renderScale }
            y={ ( rowHeight / 2 ) - 4 }
            width={ 45 }
            height={ 45 }
            anchor={ { x: 0.5, y: 0.5 } }
            scale={ currentPlayerData.isClient ? 1.2 : 1.0 }
          />

          <PixiScaledText
            text={ currentPlayerData.score.toString() }
            stageRenderData={ stageRenderData }
            x={ 82 * renderScale }
            y={ ( rowHeight / 2 ) - 2 }
            anchor={ 0.5 }
            fontSize={ 25 * renderScale }
            fontWeight={ "bold" }
            style={ {
              fill: 'white',
              stroke: 'black',
              strokeThickness: 4,
            } }
          />

        </Container>
      );
    }



    let totalPanelHeight = ( numPlayers * rowHeight ) + ( ( numPlayers - 1 ) * rowSpacing );

    return (

      <Container
        x={ -42 * stageRenderData.scale }
        y={ ( stageRenderData.height / 2 ) - ( totalPanelHeight / 2 ) }
      >
        { positionTabsContent }
        { playerScoreSegments }
      </Container>

    );
  }
}

export default PixiEndGamePhasePanel;
